import api from './apiService'; // Authenticated Axios instance (attaches the Bearer token)

// Sample collection endpoints. The API takes the lab from the JWT, so no
// LabID is sent. See docs/features/sample-collection/spec.md.
const BASE = 'Samples';

export const sampleService = {
  // Sources, statuses and conditions for dropdowns.
  getMetadata: async () => {
    const response = await api.get(`${BASE}/metadata`);
    return response.data;
  },

  // ---- Sample types ----
  getTypes: async (includeInactive = false) => {
    const response = await api.get(`${BASE}/types`, { params: { includeInactive } });
    return response.data;
  },
  addType: async (type) => {
    const response = await api.post(`${BASE}/types`, type);
    return response.data;
  },
  updateType: async (id, type) => {
    const response = await api.put(`${BASE}/types/${id}`, type);
    return response.data;
  },

  // ---- Samples ----
  // The order's tests (with which sample covers each) plus its samples.
  getForOrder: async (orderId) => {
    const response = await api.get(`${BASE}/order/${orderId}`);
    return response.data;
  },
  // filters: { status, source, sampleTypeId, startDate, endDate, searchTerm, pageNumber, pageSize }
  getList: async (filters) => {
    const params = {};
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value !== '' && value !== null && value !== undefined) params[key] = value;
    });
    const response = await api.get(BASE, { params });
    return response.data;
  },
  create: async (sample) => {
    const response = await api.post(BASE, sample);
    return response.data;
  },
  update: async (id, sample) => {
    const response = await api.put(`${BASE}/${id}`, sample);
    return response.data;
  },
  setStatus: async (id, status, rejectionReason) => {
    const response = await api.put(`${BASE}/${id}/status`, { status, rejectionReason });
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  }
};

// API validation errors come back as a plain-text 400 body.
export const sampleErrorMessage = (error, fallback) =>
  (typeof error?.response?.data === 'string' && error.response.data) || fallback;
